import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import { Link } from 'react-router-dom'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import NavGroup from './NavGroup'
import { useSelector } from 'react-redux'
import {
  Group,
  LocalHospital,
  // Today,
  Assignment,
  Build,
  AssignmentTurnedIn,
  AssignmentLate,
  Science,
  // Assessment,
} from '@mui/icons-material'
import ImageIcon from '@mui/icons-material/Image'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.white.main,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  listItem: {
    '&.MuiListItemButton-root:hover': {
      backgroundColor: 'red',
    },
    '&.Mui-selected:active': {
      background: 'rgba(0, 0, 0, 0.9)',
    },
    color: theme.palette.white.main,
    '&.MuiListItemIcon-root:active': {
      color: '#000',
    },
  },
}))

export default function NestedList() {
  const classes = useStyles()
  const user = useSelector((state) => state.user.user)
  const location = window.location.pathname.split('/').slice(1)

  return (
    <List
      component="nav"
      aria-labelledby="nested-list-subheader"
      className={classes.root}
    >
      <NavGroup role={user.role_id} allowRoles={[1, 2]}>
        <Link to="/patients">
          <ListItemButton
            selected={location[0] == 'patients' || location[0] == 'patient'}
          >
            <ListItemIcon className="menu-active">
              <Group />
            </ListItemIcon>
            <ListItemText primary="Pacjenci" />
          </ListItemButton>
        </Link>
      </NavGroup>
      <NavGroup role={user.role_id} allowRoles={[1, 2, 0]}>
        <Link to="/examinations">
          <ListItemButton selected={location[0] == 'examinations'}>
            <ListItemIcon className="menu-active">
              <Science />
            </ListItemIcon>
            <ListItemText primary="Wyniki badań" />
          </ListItemButton>
        </Link>
      </NavGroup>
      <NavGroup role={user.role_id} allowRoles={[1]}>
        <Link to="/doctors">
          <ListItemButton
            selected={location[0] == 'doctors' || location[0] == 'doctor'}
          >
            <ListItemIcon className="menu-active">
              <LocalHospital />
            </ListItemIcon>
            <ListItemText primary="Lekarze" />
          </ListItemButton>
        </Link>
        <Link to="/administrators">
          <ListItemButton
            selected={
              location[0] == 'administrators' || location[0] == 'administrator'
            }
          >
            <ListItemIcon className="menu-active">
              <Build />
            </ListItemIcon>
            <ListItemText primary="Administratorzy" />
          </ListItemButton>
        </Link>
        <Link to="/contracts">
          <ListItemButton selected={location[0] == 'contracts'}>
            <ListItemIcon className="menu-active">
              <Assignment />
            </ListItemIcon>
            <ListItemText primary="Wszystkie zlecenia" />
          </ListItemButton>
        </Link>
        <Link to="/active-contracts">
          <ListItemButton selected={location[0] == 'active-contracts'}>
            <ListItemIcon className="menu-active">
              <AssignmentTurnedIn />
            </ListItemIcon>
            <ListItemText primary="Aktywne zlecenia" />
          </ListItemButton>
        </Link>
        <Link to="/events">
          <ListItemButton selected={location[0] == 'events'}>
            <ListItemIcon className="menu-active">
              <AssignmentLate />
            </ListItemIcon>
            <ListItemText primary="Zdarzenia" />
          </ListItemButton>
        </Link>
        {user.role_id == 1 && user.permissions.includes('view Photo') && (
          <Link to="/images">
            <ListItemButton selected={location[0] == 'images'}>
              <ListItemIcon className="menu-active">
                <ImageIcon />
              </ListItemIcon>
              <ListItemText primary="Zdjęcia" />
            </ListItemButton>
          </Link>
        )}
        {/* <Link to="/reports">
          <ListItemButton selected={location[0] == 'reports'}>
            <ListItemIcon className="menu-active">
              <Assessment />
            </ListItemIcon>
            <ListItemText primary="Raporty" />
          </ListItemButton>
        </Link> */}
      </NavGroup>
    </List>
  )
}
